export const getAuthToken = () => {
    if (localStorage.getItem('user_token')) {
        return localStorage.getItem('user_token')
    }
    return '';
}
export const setRefferAddress = (address)=>{
    localStorage.setItem('refferaddress',address)
}

export const removeRefferAddress = ()=>{
    localStorage.removeItem('refferaddress')
}

export const getRefferAddress = ()=>{
    let refferAddress = localStorage.getItem('refferaddress')
    if(refferAddress){
        return refferAddress
    }
    return false
}
export const SetWallAddress = (account,wallet)=>{
    sessionStorage.setItem('accountInfo',account)
    if(wallet !=""){
        sessionStorage.setItem('wallet',wallet)
    }
}
export const getWalletAddress = () => {
    if (sessionStorage.getItem('accountInfo')) {
        return sessionStorage.getItem('accountInfo')
    }
    return '';
}
export const removeWallteAddress = () => {
    if (sessionStorage.getItem('accountInfo')) {
        sessionStorage.removeItem('accountInfo')
        sessionStorage.removeItem('wallet')
    }
    return '';
}
export const removeAuthToken = () => {
    localStorage.removeItem('user_token');
}

export const setAuthToken = (token) => {
    localStorage.setItem('user_token', token);
    return true
}

export const setTheme = async (theme) => {
    if (theme == 'dark') {
        document.body.classList.add('light_theme');
    } else {
        document.body.classList.add('light_theme');
    }
    localStorage.setItem('theme', theme);
    return theme
}

export const getTheme = () => {
    let theme = localStorage.getItem('theme');
    if (theme) {
        return theme
    }
    return 'dark'
}

export const changeTheme = (theme) => {
    if (theme == 'dark') {
        document.body.classList.add('light_theme');
    } else if (theme == 'light') {
        document.body.classList.add('light_theme');
    }
    return true;
}

export const setTradeTheme = async (theme) => {
    localStorage.setItem('tradeTheme', theme);
    if (theme == 'dark') {
        document.body.classList.add('light_theme');
    } else if (theme == 'light') {
        document.body.classList.add('light_theme');
    }
    return true;
}

export const changeTradeTheme = (theme) => {
    if (theme == 'dark') {
        document.body.classList.add('light_theme');
    } else if (theme == 'light') {
        document.body.classList.add('light_theme');
    }
    return true;
}

export const getTradeTheme = () => {
    let theme = localStorage.getItem('tradeTheme');
    if (theme) {
        return theme
    }
    return 'dark'
}

export const setLang = async (value) => {
    localStorage.setItem('lang', value);
    return true
}

export const getLang = () => {
    if (localStorage.getItem('lang')) {
        return localStorage.getItem('lang')
    }
    return '';
}

export const CleargetProfitCalculation = () => {
    let oldintervalId = localStorage.getItem('getProfitCalculation')
    if (oldintervalId) {
        clearInterval(oldintervalId);
        localStorage.removeItem('getProfitCalculation')
    }
}
export const ClearActiveCheck = () => {
    let oldintervalId = localStorage.getItem('ActiveCheck')
    if (oldintervalId) {
        clearInterval(oldintervalId);
        localStorage.removeItem('ActiveCheck')
    }
}